import React from 'react';
import styled, { css } from 'styled-components';

import { useConfig } from '../../hooks';
import { detectBrowser } from '../../utilities';
import renderTitle from './renderTitle';

const Title = styled.div`
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  overflow-wrap: anywhere;
  color: ${props => props.textColor};

  @media screen and (min-width: 768px) {
    line-height: 20px;
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const Caption = () => {
  const {
    fontFamily,
    header,
    startButton: {
      icon: { background }
    }
  } = useConfig();
  const { isIE } = detectBrowser;

  const renderAvatar = () => {
    if (isIE) {
      return (
        <AvatarWrapper
          imgUrl={header.avatar.url}
          width={header.height - 20}
          height={header.height - 20}
          background={background}
        />
      );
    }
    return (
      <Avatar
        src={header.avatar.url}
        width={header.avatar.isRealSize ? header.avatar.width : header.height - 20}
        height={header.avatar.isRealSize ? header.avatar.height : header.height - 20}
        background={background}
        isRealSize={header.avatar.isRealSize || false}
        alt="avatar"
      />
    );
  };

  return (
    <Root fontFamily={fontFamily}>
      {header.avatar.enabled && renderAvatar()}
      <Info color={header.title.color}>{renderTitle(header.title, Title)}</Info>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  align-items: center;
  margin-right: 4px !important;
  font-family: ${props => props.fontFamily};
`;

const AvatarWrapper = styled.div`
  position: relative;
  display: block;
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
  margin-right: 6px !important;
  background-color: ${props => props.background};
  background-image: ${({ imgUrl }) => `url("${imgUrl}")`};
  background-repeat: no-repeat;
  background-position: 100% 100%;
  background-size: cover;
  border-radius: 50%;
`;

const Avatar = styled.img`
  display: block;
  width: ${({ width }) => (Number(width) ? `${width}px` : width)};
  height: ${({ height }) => `${height}px`};
  margin-right: 6px;
  ${({ isRealSize }) => {
    if (!isRealSize) {
      return css`
        background: ${props => props.background};
        border-radius: 50%;
        object-fit: cover;
        object-position: 85% 50%;
      `;
    }

    return null;
  }}
`;

const Info = styled.div`
  color: ${props => props.color};

  p,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding: 0;
    margin: 0;
  }
`;
